import { KeycloakService } from 'keycloak-angular';
import { EnvService } from 'src/app/_servicos/env.service';

export function initializerKeyCloak(
  keycloak: KeycloakService,
  environment: EnvService
): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise<void>(async (resolve, reject) => {
      //console.log('teste');
      //console.log('env', environment, resolve, reject);
      //console.log('KEYKLOAK INICIADO', keycloak, environment);

      try {
        await keycloak.init({
          config: environment.keycloakConfig,
          //loadUserProfileAtStartUp: true,
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false,
          },
          //enableBearerInterceptor: true,
          //bearerPrefix: 'Bearer',
          //bearerExcludedUrls: [''],
        });

        resolve();
        //console.log('KEYKLOAK INICIADO - OK');
      } catch (error) {
        //console.log('KEYKLOAK INICIADO - ERRO', error);
        reject(error);
      }
    });
  };
  //acho que o erro pode estar na configuração do keycloak que não deixa o tal do CORS. Será que é porque utilizo localhost
}
